import { connect } from 'react-redux'
import{mainSlideChanged,showAlert} from '../actions/index.js'
import mainSliderComponent from '../components/mainSliderComponent.js'
import { savePlan } from '../actions/plan'

const mapStateToProps = (state, ownProps) => {
 return {
     measurementsSkipped: state.measurements.skipped,
     displayError: state.ui.displayError,
     slideConfiguration: state.clientConfiguration.slideConfig || "default",
     products: buildProductGroups(state.plan),  
     errorMessage: state.ui.errorMessage,
     ui: state.ui
};
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    pageChanged: (index, header, descriptionLocalizationStringName, previousSlideAvalaible, nextSlideAvalaible, materialImageDisplayed)=>{
        dispatch(mainSlideChanged(index, header, descriptionLocalizationStringName, previousSlideAvalaible, nextSlideAvalaible, materialImageDisplayed))
        if (index!==0)dispatch(savePlan());
    },
    showAlert: (message) => window.alert(message)
})

const mainSlider = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(mainSliderComponent)

let buildProductGroups = (plan) => {
    let products = [];
    if (plan.hasBench) products.push("bench");
    if (plan.hasPaneling) products.push("paneling");
    if (plan.hasLights) products.push("lights");
    if (plan.hasDoor) products.push("door");
    if (plan.hasStove) products.push("stove");
    return products;

}


export default mainSlider
